import {keys} from 'ts-transformer-keys';

import {
    DataAggregator,
    DataDescriptor,
    ObjectDataDescriptor
} from '~/shared/src/utilities/dataStructure';
import {
    Messages,
    Styles
} from '~/shared/src/utilities/dataExtraction';
import {OpenDetailViewConfig} from '~/shared/src/utilities/modules/calendar';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


/*** CFG:CalendarEvent ***/
export type CalendarEvent = {
    data : {
        id : number;
        key : string;
        name : string;

        allDayAttributePath? : string;
        allDayQueryFieldName? : string;
        backgroundAttributePath? : string;
        backgroundQueryFieldName? : string;
        detailViewIdOrKeyQueryFieldName? : string;
        detailViewItemTypeNameOrQueryFieldName? : string;
        fromAggregateFunction? : DataAggregator;
        fromAttributePath? : string;
        fromQueryFieldName? : string;
        isEditable? : boolean;
        order : number;
        toAggregateFunction? : DataAggregator;
        toAttributePath? : string;
        toQueryFieldName? : string;
    };
    rootDataDescriptor? : ObjectDataDescriptor;
    fromDataDescriptor? : DataDescriptor;
    toDataDescriptor? : DataDescriptor;
    allDayDataDescriptor? : DataDescriptor;
    backgroundDataDescriptor? : DataDescriptor;
    dataDescriptors? : DataDescriptor[];
    openDetailViewConfig? : OpenDetailViewConfig;
    messages? : Messages;
    panelConfigIds? : number[];
    permissions? : GroupPermissions;
    styles? : Styles;
};

export const calendarEventDataProps = keys<CalendarEvent['data']>();
export const calendarEventProps = keys<CalendarEvent>();
export const requiredCalendarEventProps = keys<RequiredOf<CalendarEvent>>();
